import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkResponsiblePersonGive = hashCodeCertificate('WaybillV2BulkResponsiblePersonGive')
export default WaybillV2BulkResponsiblePersonGive